<div class="py-4">
  <mat-card class="px-3">
    <mat-card-header
      class="flex align-items-center mb-3 sm:mb-0 lg:mb-0 xl:mb-0">
      <shared-title>Reportes de reservas más recientes</shared-title>
      <button
        mat-icon-button
        matTooltip="Limpiar formulario"
        matTooltipPosition="right"
        class="ml-5"
        (click)="clearForm()">
        <mat-icon>cleaning_services</mat-icon>
      </button>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="formReports" (submit)="submit()">
        <div class="grid">
          @if (isrole) {
            <mat-form-field
              class="col-12 ms:col-12 md:col-6 lg:col-6 xl:col-6"
              appearance="outline">
              <mat-label>Empresas</mat-label>
              <input
                type="text"
                aria-label="text"
                matInput
                [(ngModel)]="selectedBussinesName"
                [formControl]="myControl"
                [disabled]="!ValidBusiness_id()"
                [matAutocomplete]="auto"
                (keydown)="onKeyDown($event)" />
              <mat-autocomplete
                autoActiveFirstOption
                #auto="matAutocomplete"
                (optionSelected)="
                  onOptionSelected($event.option.value, $event.option.viewValue)
                "
                (optionSelected)="chargueDataForm()">
                @for (option of filteredOptions | async; track option) {
                  <mat-option [value]="option.idBusiness">{{
                    option.name
                  }}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          } @else {
            <mat-form-field
              class="col-12 ms:col-12 md:col-6 lg:col-6 xl:col-6"
              appearance="outline">
              <mat-label>Empresa</mat-label>
              <mat-select
                required
                [disabled]="!ValidBusiness_id()"
                (selectionChange)="chargueDataForm()"
                [(value)]="selectedBussines">
                @for (item of bussines; track item) {
                  <mat-option [value]="item.idBusiness">{{
                    item.name
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          <mat-form-field
            class="col-12 ms:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Seleccione el rango</mat-label>
            <mat-date-range-input [rangePicker]="rangePicker">
              <input
                matStartDate
                placeholder="Fecha Inicial"
                formControlName="startDate"
                readonly />
              <input
                matEndDate
                placeholder="Fecha FInal"
                formControlName="endDate"
                readonly />
            </mat-date-range-input>

            <mat-datepicker-toggle
              matIconSuffix
              [for]="rangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker>
              <mat-date-range-picker-actions>
                <button mat-button matDateRangePickerCancel>Cancelar</button>
                <button
                  mat-raised-button
                  color="primary"
                  matDateRangePickerApply>
                  Elegir
                </button>
              </mat-date-range-picker-actions>
            </mat-date-range-picker>
          </mat-form-field>

          <mat-form-field
            class="col-12 ms:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Tipo de puesto</mat-label>
            <mat-select formControlName="workplaceTypeId">
              @for (workplace of ptypeJobs; track workplace) {
                <mat-option
                  [value]="workplace.workplacetypeid"
                  (click)="filterWorkplacesByTypeId(workplace.workplacetypeid)"
                  >{{ workplace.name }}</mat-option
                >
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field
            class="col-12 ms:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Edificio</mat-label>
            <mat-select formControlName="buildingId">
              @for (building of buildings; track building) {
                <mat-option
                  [value]="building.buildingid"
                  (click)="chargueFloorByBuilding(building.buildingid)"
                  >{{ building.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field
            class="col-12 ms:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Nivel</mat-label>
            <mat-select formControlName="floorId">
              @for (floor of floors; track floor) {
                <mat-option
                  [value]="floor.floorid"
                  (click)="chargueWorkplaces(floor.floorid)"
                  >{{ floor.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field
            class="col-12 ms:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Puesto de Trabajo</mat-label>
            <mat-select formControlName="workplaceId">
              @for (workplace of workplacesFilter(); track workplace) {
                <mat-option [value]="workplace.workplaceid">{{
                  workplace.name
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field
            class="col-12 ms:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Estatus</mat-label>
            <mat-select formControlName="reservationStatusId">
              @for (reserv of ReservationStatus(); track reserv) {
                <mat-option [value]="reserv.reservationStatusId">{{
                  reserv.name
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <shared-input
            class="col-12 ms:col-12 md:col-6 lg:col-6 xl:col-6"
            [labelTitle]="'Usuario'"
            [control]="$any(formReports.get('worker'))" />
        </div>

        <div class="grid">
          <shared-button
            [icon]="'search'"
            [typeBtn]="'button'"
            (click)="findData()"
            color="accent"
            [disabled]="!ValidForms()"
            class="col-fixed">
            Buscar
          </shared-button>
          <div class="col flex gap-3 justify-content-end">
            <shared-button
              [icon]="'save_alt'"
              [typeBtn]="'button'"
              (click)="downloadCsv()"
              [disabled]="!ValidForms()"
              color="accent">
              Descargar CSV
            </shared-button>
            <shared-button
              [icon]="'save_alt'"
              [typeBtn]="'button'"
              [disabled]="!ValidForms()"
              (click)="downloadPDF()"
              color="accent">
              Descargar PDF
            </shared-button>
          </div>
        </div>
      </form>
      <br />
      <div class="shadow-2 overflow-auto">
        <table mat-table [dataSource]="dataSource">
          <!-- Date Column -->
          <ng-container matColumnDef="start" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Fecha Inicial
            </th>
            <td mat-cell *matCellDef="let element">{{ element.inicio }}</td>
          </ng-container>
          <!-- Date Column -->
          <ng-container matColumnDef="end" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Fecha Final
            </th>
            <td mat-cell *matCellDef="let element">{{ element.fin }}</td>
          </ng-container>
          <!-- User Column -->
          <ng-container matColumnDef="checkin">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Fecha Checkin
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.checkin }}
            </td>
          </ng-container>
          <!-- Name Column -->
          <ng-container matColumnDef="checkout">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Fecha Checkout
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.checkout }}
            </td>
          </ng-container>
          <!-- User Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
            <td mat-cell *matCellDef="let element">
              {{ element.nombre }}
            </td>
          </ng-container>
          <!-- User Column -->
          <ng-container matColumnDef="last_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Apellido</th>
            <td mat-cell *matCellDef="let element">
              {{ element.apellido }}
            </td>
          </ng-container>
          <!-- User Column -->
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Correo</th>
            <td mat-cell *matCellDef="let element">
              {{ element.correo }}
            </td>
          </ng-container>
          <!-- User Column -->
          <ng-container matColumnDef="workstation">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Puesto</th>
            <td mat-cell *matCellDef="let element">
              {{ element.puesto }}
            </td>
          </ng-container>
          <!-- User Column -->
          <ng-container matColumnDef="jobType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Tipo de Puesto
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.tipo_puesto }}
            </td>
          </ng-container>
          <!-- User Column -->
          <ng-container matColumnDef="level">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nivel</th>
            <td mat-cell *matCellDef="let element">
              {{ element.nivel }}
            </td>
          </ng-container>
          <ng-container matColumnDef="building">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Edificio</th>
            <td mat-cell *matCellDef="let element">
              {{ element.edificio }}
            </td>
          </ng-container>
          <!-- User Column -->
          <ng-container matColumnDef="hours" stickyEnd>
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Horas</th>
            <td mat-cell *matCellDef="let element">
              {{ element.horas }}
            </td>
          </ng-container>
          <!-- User Column -->
          <ng-container matColumnDef="state" stickyEnd>
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Estado de Reserva
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.estado }}
            </td>
          </ng-container>
          <ng-container matColumnDef="options">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <button
                mat-icon-button
                color="accent"
                [matMenuTriggerFor]="menu"
                aria-label="Mas opciones">
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #menu="matMenu">
                <!--
                <a mat-menu-item (click)="modalAction(element)">
                  <mat-icon mat-icon-button>edit</mat-icon>
                  <span>Editar</span>
                </a>
                -->

                @if (element.estado === 'EN ESPERA') {
                  <a mat-menu-item (click)="modalAction(element)">
                    <mat-icon mat-icon-button color="warn">delete</mat-icon>
                    <span>Eliminar</span>
                  </a>
                } @else {
                  <span>No hay opciones disponibles</span>
                }
              </mat-menu>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <br />
      <mat-paginator
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
        aria-label="Select page of periodic elements">
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
